import Loader from "@spz/ui/components/loader";
import { Suspense } from "react";
import { Outlet } from "react-router";

export const GuestLayout: React.FC = () => {
  return (
    <div>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </div>
  );
};
